import { useEffect, useState } from "react";
import { useAppSelector } from "../../../_app";
import { DashboardService } from "../../../_service/DashboardService";
import { Constant } from "../../../config";
import { Notify } from "../../../utils";
import { RequestTable } from "../RequestTable";
import { LoaderContainer } from "../../../CommonStyles";
import { Loader } from "../../../components";

const CsoDashboard = () => {
  const [requestData, setRequestData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const user = useAppSelector((state) => state.user);

  const getSubmittedRequests = async () => {
    setIsLoading(() => true)
    try {
      const { status, data } = await DashboardService._getSubmittedRequests(
        user.defaultCompnayId,
        "CSO"
      );
      if (status === 200) {
        setRequestData(() => data.data);
      }
    } catch (error) {
      Notify(Constant.common.something_went_wrong, 0);
    }
    setIsLoading(() => false)
  };

  useEffect(() => {
    getSubmittedRequests();
  }, []);
  return (
    <div>
      {isLoading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <RequestTable data={requestData} getSubmittedRequests={getSubmittedRequests} />
      )}
    </div>
  );
};

export default CsoDashboard;
